var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('ui-modal',{attrs:{"label":_vm.label},on:{"close":_vm.close}},[_c(_vm.content,{tag:"content"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }